import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import { Component } from 'react';

var StatusBar = function (_Component) {
  _inheritsLoose(StatusBar, _Component);

  function StatusBar() {
    return _Component.apply(this, arguments) || this;
  }

  StatusBar.setBackgroundColor = function setBackgroundColor() {};

  StatusBar.setBarStyle = function setBarStyle() {};

  StatusBar.setHidden = function setHidden() {};

  StatusBar.setNetworkActivityIndicatorVisible = function setNetworkActivityIndicatorVisible() {};

  StatusBar.setTranslucent = function setTranslucent() {};

  var _proto = StatusBar.prototype;

  _proto.render = function render() {
    return null;
  };

  return StatusBar;
}(Component);

export { StatusBar as default };